export default "__VITE_ASSET__BfNM36pj__"